
export enum ReportState {
	Done,
	Ongoing,
	AwaitingApproval,
	Archived
}
export enum ReportSorting {
	NewestFirst
}
